// eslint-disable-next-line drops/no-direct-spor-import
import { DialogContent } from "@vygruppen/spor-react";
import { ComponentProps } from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { ThemeSemantic, useThemeOrSemantic } from "shared/theme/themeSemantic";
import { FCWC } from "shared/utils/FCWC";
import styled from "styled-components";

type DialogContentProps = ComponentProps<typeof DialogContent>;

type DropsDialogContentProps = DialogContentProps & {
  semantics?: Semantics;
};

const StyledDialogContent = styled(DialogContent)<{
  theme: ThemeSemantic;
}>`
  background-color: ${({ theme }) => theme.colorSemanticFill};
  border: 1px solid ${({ theme }) => theme.colorSemanticOutline};
  .spor-dialog__body {
    background-color: ${({ theme }) => theme.colorSemanticFillPulse};
    border: 1px solid ${({ theme }) => theme.colorSemanticOutline};
  }
`;

export const InternalDropsDialogContent: FCWC<DropsDialogContentProps> = ({
  children,
  semantics,
  ...props
}) => {
  const theme = useThemeOrSemantic(semantics);
  if (!semantics) return <DialogContent {...props}>{children}</DialogContent>;
  return (
    <StyledDialogContent theme={theme} {...props}>
      {children}
    </StyledDialogContent>
  );
};
